import React, { useState, FormEvent, ChangeEvent, FC } from 'react';
import Navbar from '../componenets/Navbar';
import Footer from '../componenets/Footer';
import '../App.css'; // Import the custom CSS file

// Define the type for common SVG component props
interface IconProps {
  className?: string;
  [key: string]: any;
}

// Icon Components
const Mail: FC<IconProps> = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);

// const Phone: FC<IconProps> = (props) => (
//   <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
//   </svg>
// );

// const MapPin: FC<IconProps> = (props) => (
//   <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
//     <circle cx="12" cy="10" r="3"/>
//   </svg>
// );

// Define Form Data Interface
interface FormData {
  name: string;
  email: string;
  subject: string;
  message: string;
}

const ContactUsPage: FC = () => {
  const [formData, setFormData] = useState<FormData>({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [status, setStatus] = useState<string>('');

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setStatus('');
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    console.log('Form Data Submitted:', formData);
    
    setTimeout(() => {
      setStatus('Message sent successfully! We will get back to you shortly.');
      setFormData({ name: '', email: '', subject: '', message: '' });
    }, 1500);
  };

  // Contact Info Card Component
  interface ContactInfoCardProps {
    Icon: FC<IconProps>;
    title: string;
    content: React.ReactNode;
  }
  
  const ContactInfoCard: FC<ContactInfoCardProps> = ({ Icon, title, content }) => (
    <div className="contact-info-card">
      <Icon className="contact-info-card-icon" />
      <h3 className="contact-info-card-title">{title}</h3>
      <div className="contact-info-card-content">{content}</div>
    </div>
  );

  // Input Field Component
  interface InputFieldProps {
    label: string;
    name: keyof FormData;
    type?: string;
    value: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    required?: boolean;
  }

  const InputField: FC<InputFieldProps> = ({ label, name, type = 'text', value, onChange, required = true }) => (
    <div className="contact-form-group">
      <label htmlFor={name} className="contact-form-label">
        {label}
      </label>
      <input
        type={type}
        id={name}
        name={name}
        value={value}
        onChange={onChange as (e: ChangeEvent<HTMLInputElement>) => void}
        required={required}
        className="contact-form-input"
      />
    </div>
  );

  // TextArea Field Component
  interface TextAreaFieldProps {
    label: string;
    name: keyof FormData;
    value: string;
    onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
    required?: boolean;
  }

  const TextAreaField: FC<TextAreaFieldProps> = ({ label, name, value, onChange, required = true }) => (
    <div className="contact-form-group">
      <label htmlFor={name} className="contact-form-label">
        {label}
      </label>
      <textarea
        id={name}
        name={name}
        rows={4}
        value={value}
        onChange={onChange as (e: ChangeEvent<HTMLTextAreaElement>) => void}
        required={required}
        className="contact-form-textarea"
      />
    </div>
  );

  return (
    <div className="contact-page-wrapper">
      <Navbar />
      
      <main className="contact-page-main">
        <div className="contact-page-container">
          
          {/* Header Section */}
          <header className="contact-page-header">
            <h1 className="contact-page-title">Get in Touch</h1>
            <p className="contact-page-subtitle">
              We're here to help with your tariff inquiries, support requests, and feedback.
            </p>
          </header>

          {/* Contact Info Cards Section */}
          <section className="contact-info-grid">
            <ContactInfoCard 
              Icon={Mail} 
              title="Email Support" 
              content={
                <a href="mailto:info@imports.lk" className="contact-info-card-link">
                  info@imports.lk
                </a>
              }
            />
            {/* <ContactInfoCard 
              Icon={Phone} 
              title="Call Us" 
              content={
                <a href="tel:+94777595331" className="contact-info-card-link">
                  +94 777 595 331 (Mon - Fri, 9am - 5pm)
                </a>
              }
            /> */}
            {/* <ContactInfoCard 
              Icon={MapPin} 
              title="Our Office" 
              content="123 Customs Road, Colombo 03, Sri Lanka"
            /> */}
          </section>

          {/* Contact Form Section */}
          <section className="contact-form-section">
            <h2 className="contact-form-title">Send Us a Message</h2>
            <form onSubmit={handleSubmit} className="contact-form-wrapper">
              <div className="contact-form-row contact-form-row-split">
                <InputField
                  label="Full Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
                <InputField
                  label="Email Address"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              
              <InputField
                label="Subject / HS Code Inquiry"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
              />

              <TextAreaField
                label="Your Message"
                name="message"
                value={formData.message}
                onChange={handleChange}
              />

              {status && (
                <div className={`contact-form-status ${
                  status.includes('successfully') 
                    ? 'contact-form-status-success' 
                    : 'contact-form-status-error'
                }`}>
                  {status}
                </div>
              )}

              <button type="submit" className="contact-form-submit-btn">
                Submit Inquiry
              </button>
            </form>
          </section>

        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ContactUsPage;